// <s-header-search> — header search pill: cycles the "Search for …" hint and adds voice input where the browser supports it.
class SHeaderSearch extends HTMLElement {
  #timer = 0;
  #index = 0;
  #recognition = null;

  connectedCallback() {
    const hints = (this.dataset.hints || '').split('|').map((h) => h.trim()).filter(Boolean);
    const word = this.querySelector('[data-search-hint-word]');
    if (word && hints.length > 0) {
      word.textContent = hints[0];
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && hints.length > 1) {
        this.#timer = window.setInterval(() => {
          this.#index = (this.#index + 1) % hints.length;
          word.classList.remove('is-swapping');
          void word.offsetWidth;
          word.textContent = hints[this.#index];
          word.classList.add('is-swapping');
        }, 2600);
      }
    }

    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const voice = this.querySelector('[data-voice-search]');
    const input = this.querySelector('input[name="q"]');
    const form = this.querySelector('form');
    if (Recognition && voice && input && form) {
      voice.hidden = false;
      voice.addEventListener('click', () => {
        if (this.#recognition) {
          this.#recognition.stop();
          return;
        }
        const recognition = new Recognition();
        recognition.lang = document.documentElement.lang || 'en-US';
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;
        recognition.addEventListener('result', (event) => {
          const text = event.results[0][0].transcript;
          input.value = text;
          form.requestSubmit();
        });
        recognition.addEventListener('end', () => {
          voice.removeAttribute('data-listening');
          this.#recognition = null;
        });
        this.#recognition = recognition;
        voice.setAttribute('data-listening', '');
        recognition.start();
      });
    }
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
    if (this.#recognition) this.#recognition.abort();
  }
}

if (!customElements.get('s-header-search')) customElements.define('s-header-search', SHeaderSearch);
